import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { ga, useUiLangState, getEggBalance } from "./GaPrimitives";
import { GaDialogShell, Eyebrow, Body, GaLimeCta, fillCopy } from "./GaDialogs";
import eggCollectedArt from "../../assets/img/1 APP INTRO & FIRST LAUNCH/egg-collected-art-4x.webp";

export function PuzzleRewardDialog({
  open,
  eggsGained = 25,
  newBalance,
  art,
  onClose,
}) {
  const { t } = useUiLangState();
  const d = t.dialogs;
  const profile = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("profileData") || "null");
    } catch {
      return null;
    }
  }, [open]);
  const balance = newBalance ?? getEggBalance(profile);

  return (
    <GaDialogShell open={open} onClose={onClose}>
      <Eyebrow>{d.puzzleComplete}</Eyebrow>
      <Typography
        sx={{
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          fontSize: 20,
          letterSpacing: "1px",
          color: ga.white,
          mb: 1.5,
        }}
      >
        {d.rewardsCollected}
      </Typography>
      <Box
        sx={{
          width: "100%",
          height: 120,
          mb: 1.5,
          bgcolor: ga.bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={art || eggCollectedArt}
          alt=""
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
      <Typography
        sx={{
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          fontSize: 18,
          color: ga.lime,
          mb: 0.5,
        }}
      >
        {fillCopy(d.plusEggs, { n: eggsGained })}
      </Typography>
      <Body sx={{ mb: 2 }}>{fillCopy(d.newBalance, { n: balance })}</Body>
      <GaLimeCta onClick={onClose}>{d.awesome}</GaLimeCta>
    </GaDialogShell>
  );
}
